<template>
  <div class="vm-invite-list">
    <Item v-for="item in list" :key="item.uuid" v-bind="item" @toggle="toggle(item)" />
  </div>
</template>

<script>
import Item from './item';

export default {
  props: {
    selectedUsers: Array,
    users: Array
  },
  components: { Item },
  methods: {
    toggle(item) {
      if (item.selected) {
        this.$emit('unselectedUser', item);
      } else {
        this.$emit('selectedUser', item);
      }
    }
  },
  computed: {
    list() {
      return this.users.map(user => {
        const selected = this.selectedUsers
          .findIndex(selectedUser => selectedUser.uuid === user.uuid) > -1;
        return { ...user, selected };
      });
    }
  }
};
</script>
